/**
 * Class to capture commitment PromiseKeeper event
 */
export class CommitmentEvent {
    /**
     * @remarks - Agent Id. For Type "S" callbacks set with Max, the agent id will be the agent that schedules callback. 
     *  For Type "S" callbacks set with Thin Agent, the agent id will return "-1".
     */
    public agentId!: string;
    /**
     * @remarks - ISO 8601 time for callback expire
     */
    public callbackExpireTime!: string;
    /**
     * @remarks - Scheduled Callback Id
     */
    public callbackId!: string;
    /**
     * @remarks - ISO 8601 time requested for Scheduled Callback
     */
    public callbackTime!: string;
    /**
     * @remarks - Rescheduled time which is reschedules for 10 minutes if we are not responded commitment
     */
    public deliveryTime!: string;
    /**
     * @remarks - Phone number to be dialed by Agent
     */
    public dialNumber!: string;
    /**
     * @remarks - First name of Agent callback is targeted to
     */
    public firstName!: string;
    /**
    * @remarks - Last name of Agent callback is targeted to
    */
    public lastName!: string;
    /**
     * @remarks - Any notes entered into the Scheduled Callback
     */
    public notes!: string;
    /**
     * @remarks - Phone number from which the Scheduled Callback originated
     */
    public origNumber!: string;
    /**
     * @remarks - Outbound Skill Id to be used for callback
     */
    public skillId!: string;
    /**
     * @remarks - Targeted type - Agent or Skill
     */
    public targetType!: string;
  
    /**
     * This method to parse promise keeper event data
     * @param data -
     * @example -
     * ```
     *parse(data);
     * ```
     */
    public parse(data: { [key: string]: string }): void {
      this.agentId = data.AgentId;
      this.callbackExpireTime = data.CallbackExpireTime
      this.callbackId = data.CallbackId
      this.callbackTime = data.CallbackTime
      this.deliveryTime = data.DeliveryTime
      this.dialNumber = data.DialNumber
      this.firstName = data.FirstName
      this.lastName = data.LastName
      this.notes = data.Notes
      this.origNumber = data.OrigNumber
      this.skillId = data.SkillId
      this.targetType = data.TargetType
    }
  }
  